<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="!contact">
      <span class="loader"></span>
    </span>
    <contact-form
      v-if="contact"
      :loading="loading"
      :contactData="contact"
      :formErrors="formErrors"
      @contactSubmitted="handleSubmit"
      @formChanged="() => (alertLeave = true)"
    />
  </div>
</template>

<script>
import ContactForm from "../partials/ContactForm.vue";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import requestErrorMixin from "@/mixins/request-error-mixin";

export default {
  layout: "DashboardLayout",

  components: { ContactForm },

  mixins: [alertLeave, requestErrorMixin],

  props: {
    contactId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      contact: null,
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;
      try {
        await this.$store.dispatch("contacts/get", this.contactId);
        this.contact = this.$store.getters["contacts/contact"];
        if (this.contact.contactable.type === "customers") {
          this.contact = {
            ...this.contact,
            customer_id: this.contact.contactable.id,
          };
        }

        if (this.contact.contactable.type === "suppliers") {
          this.contact = {
            ...this.contact,
            supplier_id: this.contact.contactable.id,
          };
        }
        this.loading = false;
      } catch (error) {
        this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: `Oops, something went wrong!`,
        });
        this.loading = false;
      }
    },

    async handleSubmit(contact) {
      this.loading = true;
      const contactData = cloneDeep(contact);

      try {
        await this.$store.dispatch("contacts/update", contactData);
        this.$notify({
          type: "success",
          timeout: 3000,
          message: this.$t("CONTACTS.CONTACT_UPDATED"),
        });
        const contact = await this.$store.getters["contacts/contact"];
        this.$emit("onViewContact", contact, true);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
